export var IdShowMeFeature;
(function (IdShowMeFeature) {
    IdShowMeFeature[IdShowMeFeature["BuildingMenu"] = 0] = "BuildingMenu";
})(IdShowMeFeature || (IdShowMeFeature = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/IdShowMeFeature.ts
// module id = 598
// module chunks = 3